import React from 'react';
import { Card, Typography, Row, Col, List, Button, Divider } from 'antd';
import { FileTextOutlined, UserOutlined, RiseOutlined, CalendarOutlined, PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import './Admissions.less';

const { Title, Paragraph, Text } = Typography;

const Admissions: React.FC = () => {
  // 招生信息数据
  const admissionInfo = [
    {
      title: '招生计划',
      icon: <FileTextOutlined />,
      content: '2024年我校计划招生3000人，涵盖20个本科专业和10个专科专业。'
    },
    {
      title: '报考指南',
      icon: <UserOutlined />,
      content: '详细的报考流程、录取规则和专业介绍，帮助考生顺利报考。'
    },
    {
      title: '就业情况',
      icon: <RiseOutlined />,
      content: '我校毕业生就业率连续五年保持在95%以上，就业质量稳步提升。'
    },
    {
      title: '招生日历',
      icon: <CalendarOutlined />,
      content: '重要时间节点，包括报名时间、考试时间和录取时间。'
    }
  ];

  // 招生政策列表
  const policies = [
    '2024年本科招生章程',
    '2024年专科招生章程',
    '艺术类专业招生办法',
    '体育类专业招生办法',
    '少数民族预科班招生办法',
    '国家专项计划招生办法',
    '地方专项计划招生办法',
    '农村订单定向医学生免费培养计划'
  ];

  // 就业数据
  const employmentData = [
    { name: '毕业生总数', value: '2850人' },
    { name: '就业率', value: '96.2%' },
    { name: '升学人数', value: '720人' },
    { name: '就业人数', value: '2135人' },
    { name: '平均起薪', value: '5800元/月' },
    { name: '优质企业就业率', value: '68.5%' }
  ];

  return (
    <div className="admissions-page">
      {/* 页面标题 */}
      <Title level={2}>招生就业</Title>
      <Paragraph>欢迎访问我校招生就业页面，这里提供最新的招生信息和就业情况。</Paragraph>
      <Divider />

      {/* 招生信息概览 */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {admissionInfo.map((item, index) => (
          <Col xs={24} sm={12} md={6} key={index}>
            <Card hoverable className="info-card">
              <div className="info-card-content">
                <div className="info-icon">{item.icon}</div>
                <Title level={4}>{item.title}</Title>
                <Paragraph>{item.content}</Paragraph>
                <Button type="primary" size="small">了解更多</Button>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      {/* 招生政策 */}
      <Card title="招生政策" className="section-card" style={{ marginBottom: 24 }}>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            <List
              dataSource={policies}
              renderItem={(item) => (
                <List.Item>
                  <FileTextOutlined style={{ marginRight: 8 }} />
                  <a href="#">{item}</a>
                </List.Item>
              )}
            />
          </Col>
          <Col xs={24} md={12}>
            <Card title="招生咨询" className="contact-card">
              <div className="contact-item">
                <PhoneOutlined /> <Text strong>咨询电话：</Text> 010-12345678
              </div>
              <div className="contact-item">
                <MailOutlined /> <Text strong>电子邮箱：</Text> admissions@example.edu.cn
              </div>
              <div className="contact-item">
                <EnvironmentOutlined /> <Text strong>办公地址：</Text> 北京市海淀区学府路1号招生办公室
              </div>
              <div className="contact-item">
                <CalendarOutlined /> <Text strong>办公时间：</Text> 周一至周五 8:30-17:30
              </div>
            </Card>
          </Col>
        </Row>
      </Card>

      {/* 就业情况 */}
      <Card title="就业情况" className="section-card">
        <Row gutter={[24, 24]}>
          <Col xs={24} md={12}>
            <Card title="就业数据" className="data-card">
              <div className="employment-data">
                {employmentData.map((item, index) => (
                  <div className="data-item" key={index}>
                    <Text strong>{item.name}：</Text> {item.value}
                  </div>
                ))}
              </div>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card title="就业单位类型分布" className="chart-card">
              <div className="chart-placeholder">
                <Paragraph>企业：65%</Paragraph>
                <Paragraph>事业单位：20%</Paragraph>
                <Paragraph>政府机关：10%</Paragraph>
                <Paragraph>自主创业：5%</Paragraph>
              </div>
            </Card>
          </Col>
        </Row>
      </Card>

      {/* 就业服务 */}
      <Card title="就业服务" className="section-card" style={{ marginTop: 24 }}>
        <Paragraph>
          我校就业指导中心为毕业生提供全方位的就业服务，包括：
        </Paragraph>
        <List
          dataSource={[
            '就业信息发布',
            '简历制作指导',
            '面试技巧培训',
            '校园招聘会',
            '企业宣讲会',
            '职业规划咨询',
            '创业指导服务',
            '校友资源对接'
          ]}
          renderItem={(item) => (
            <List.Item>
              <span className="list-icon">•</span> {item}
            </List.Item>
          )}
          grid={{ gutter: 16, column: 2 }}
        />
      </Card>
    </div>
  );
};

export default Admissions;